import { combineReducers } from "redux";

import themeReducer from "./themeReducer";
import { default as projectReducer } from "./projectReducer";

export const rootReducer = combineReducers({
  themeReducer,
  projectReducer,
});
